import React, { useMemo } from "react";
import { Text } from "@geist-ui/core";
import { Flex } from "@radix-ui/themes";

import { useTopicDraft } from "../../context/useTopicDraft";
import { topicToTopicWithBadges } from "../topicsList/TopicsList.types";
import { TopicBadge } from "../topicsList/TopicBadge";

interface TopicHeaderProps {
  topic: string;
  topicId: number;
}

export const TopicHeader: React.FC<TopicHeaderProps> = ({ topic, topicId }) => {
  const { draftDetails } = useTopicDraft({ topicId });
  const topicsWithBadges = useMemo(
    () => (draftDetails ? topicToTopicWithBadges(draftDetails) : null),
    [draftDetails]
  );

  return (
    <Flex align="center" gap="2">
      <Text h4 style={{ textTransform: "capitalize" }}>
        {topic}
      </Text>
      <Flex gap="2">
        {topicsWithBadges?.badges.badges.map((badge, index) => (
          <TopicBadge key={index} badge={badge} />
        ))}
      </Flex>
    </Flex>
  );
};
